document.addEventListener("DOMContentLoaded", (event) => {
  var swiper = new Swiper(".mySwiper", {
    slidesPerView: 5.5,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
      767: {
        slidesPerView: 5.5,
      },
      600: {
        slidesPerView: 9,
      },
      500: {
        slidesPerView: 7,
      },
      0: {
        slidesPerView: 5.5,
      },
    },
  });

  var swiper2 = new Swiper(".mySwiper2", {
    slidesPerView: "auto",
    spaceBetween: 5,
    thumbs: {
      swiper: swiper,
    },
  });

  /* Complete your script */
  var swiper3 = new Swiper(".mySwiper3", {
    spaceBetween: 10,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      1024: {
        slidesPerView: 1.5,
      },
      650: {
        slidesPerView: 2,
      },
      500: {
        slidesPerView: 1.5,
      },
      0: {
        slidesPerView: 1,
      },
    },
  });

  function goToSlide(index) {
    swiper.slideTo(index);
    swiper2.slideTo(index);
  }

  const variantItems = document.querySelectorAll(
    ".variant-container .variant-element"
  );

  function addVariantIdToUrl() {
    let currentUrl = window.location.href;

    if (currentUrl.includes(window.product_handle)) {
      let baseUrl = currentUrl.split("?")[0];
      let updatedUrl =
        baseUrl +
        (baseUrl.includes("?") ? "&" : "?") +
        "variant=" +
        window.variant_id;

      window.history.pushState({}, "", updatedUrl);
    }
  }

  variantItems.forEach((item) => {
    item.addEventListener("click", function (event) {
      event.stopPropagation();
      event.preventDefault();

      const index = parseInt(this.getAttribute("index"), 10);
      const price = this.getAttribute("price");

      variantItems.forEach((variant) => {
        const input = variant.querySelector(
          "input[type='radio'], input[type='checkbox']"
        );
        if (input) {
          input.checked = false;
        }
      });

      const currentInput = this.querySelector(
        "input[type='radio'], input[type='checkbox']"
      );

      if (currentInput) {
        currentInput.checked = true;
      }

      window.variant_id = this.getAttribute("variant_id");
      let sold_out = this.getAttribute("sold_out") === "true";

      setSoldOut(sold_out);
      goToSlide(index);
      moveImageToFirstIndex(index);
      changePrice(price);
      changeDesktopImages();
      addVariantIdToUrl();
    });

    addVariantIdToUrl();
  });

  function changeDesktopImages() {
    let images = document.querySelectorAll(".product-images-desktop img");
    images.forEach((img, i) => {
      img.src = window.product_images[i];
    });
  }

  function moveImageToFirstIndex(index) {
    let product_images = [...window.original_product_images];
    if (index >= 0 && index < product_images.length) {
      let imageToMove = product_images.splice(index, 1)[0];
      product_images.unshift(imageToMove);
    }
    window.product_images = [...product_images];
  }

  function changePrice(price) {
    let currentPrice = document.querySelector(".pdp-price");
    currentPrice.innerHTML = price;
  }

  function setSoldOut(sold_out) {
    let currentPrice = document.querySelector(".add-to-cart");

    if (sold_out) {
      currentPrice.textContent = "Sold out";
      currentPrice.setAttribute("value", "Sold out");
    } else {
      currentPrice.textContent = "Add to Cart";
      currentPrice.setAttribute("value", "");
    }
  }
});

/*   Accordion script */
document.querySelectorAll(".accordion-button").forEach((button) => {
  button.addEventListener("click", function () {
    const accordion = this.parentElement;
    accordion.classList.toggle("open");

    const content = accordion.querySelector(".accordion-content");
    if (accordion.classList.contains("open")) {
      content.style.maxHeight = content.scrollHeight + "px";
    } else {
      content.style.maxHeight = 0;
    }
  });
});
